import type {AssetStoryblok} from '~/storyblok/types';

type ArticleHeroImageKey = 'article' | 'articleLepsiSvet' | 'recipe' | 'pressRelease';

export type ArticleHeroImage = Pick<AssetStoryblok, 'filename' | 'focus'> & {width?: number; height?: number};

const articleHeroImages: Record<ArticleHeroImageKey, ArticleHeroImage> = {
	article: {
		filename: '/images/articleHeroImages/article.jpg',
		focus: '1100x140:1101x141',
		width: 3840,
		height: 600,
	},
	articleLepsiSvet: {
		filename: '/images/articleHeroImages/article_lepsi_svet.jpg',
		focus: '3000x240:3001x241',
		width: 3840,
		height: 600,
	},
	recipe: {
		filename: '/images/articleHeroImages/recipe.jpg',
		focus: '2280x260:2281x261',
		width: 3840,
		height: 600,
	},
	pressRelease: {
		filename: '/images/articleHeroImages/press_release.jpg',
		focus: '870x330:871x331',
		width: 3840,
		height: 600,
	},
};

export default articleHeroImages;
